/**
 * @license Copyright (c) Microsoft Corporation.  All rights reserved.
 */
import { HtmlAttributes } from "../Constants/HtmlAttributes";
export var findCheckboxes = function (element) {
    return element.querySelectorAll('input[type="checkbox"]');
};
export var findRadioButtons = function (element) {
    return element.querySelectorAll('input[type="radio"]');
};
export var findFieldBlocksOfType = function (element, blockType) {
    return element.querySelectorAll("[".concat(HtmlAttributes.editorBlockType, "=\"").concat(blockType, "\"]"));
};
export var isFieldBlockRequired = function (block) {
    return block.hasAttribute(HtmlAttributes.dataRequired);
};
export var findLabels = function (element) {
    return element.querySelectorAll("label");
};
export var getParentElement = function (element, filter) {
    while (element) {
        if (filter(element)) {
            return element;
        }
        element = element.parentElement;
    }
    return element;
};
export var findParentFieldBlock = function (childElement) { return getParentElement(childElement, function (el) { return el.hasAttribute(HtmlAttributes.editorBlockType); }); };
/**
 * Looks for an attribute in data field block by going up the hierarchy (search includes given element) and returns its value.
 * If the given attribute name is not found earlier, search stops at element with data-editorblocktype.
 * Returns null if the attribute is not found, otherwise its value.
 * @param childElement the child element to start search from (preferably input)
 * @param attrName name of the attribute to look for
 */
export var findAttributeInFieldBlock = function (childElement, attrName) {
    var parentElement = getParentElement(childElement, function (el) { return el.hasAttribute(attrName) || el.hasAttribute(HtmlAttributes.editorBlockType); });
    if (parentElement === null || parentElement === void 0 ? void 0 : parentElement.hasAttribute(attrName)) {
        return parentElement.getAttribute(attrName);
    }
    return null;
};
export var doesPhoneNumberStartWithCountryCode = function (phoneNumber) {
    var phoneNumberWithoutIllegalCharacters = phoneNumber.replace(/[^0-9\+]/g, "");
    var internationalCodes = ["+", "00", "011", "010"];
    return internationalCodes.some(function (internationalCode) { return phoneNumberWithoutIllegalCharacters.startsWith(internationalCode); });
};
